import { Outlet } from "react-router";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Sidebar from "./sidebar/Sidebar";
import applyLanguageToDocument from "../../utils/shared/applyLanguageToDocument";

function DashboardLayout() {
  const { i18n } = useTranslation();

  useEffect(() => {
    applyLanguageToDocument(i18n.language);
  }, [i18n.language]);

  return (
    <div className="container-fluid dashboard-layout">
      <div className="row flex-nowrap">
        <Sidebar />
        <Outlet />
      </div>
    </div>
  );
}

export default DashboardLayout;
